import React from "react";
import { colors } from "@/components/AlertWithBorder";

const Link = () => (
  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.33333 1.83333C6.96514 1.83333 6.66667 1.53486 6.66667 1.16667C6.66667 0.798477 6.96514 0.5 7.33333 0.5H11.3333C11.7015 0.5 12 0.798477 12 1.16667V5.16667C12 5.53486 11.7015 5.83333 11.3333 5.83333C10.9651 5.83333 10.6667 5.53486 10.6667 5.16667V2.77614L5.13807 8.30474C4.87772 8.56509 4.45561 8.56509 4.19526 8.30474C3.93491 8.04439 3.93491 7.62228 4.19526 7.36193L9.72386 1.83333H7.33333ZM2 3.16667C1.63181 3.16667 1.33333 3.46514 1.33333 3.83333V10.5C1.33333 10.8682 1.63181 11.1667 2 11.1667H8.66667C9.03486 11.1667 9.33333 10.8682 9.33333 10.5V7.83333C9.33333 7.46514 9.63181 7.16667 10 7.16667C10.3682 7.16667 10.6667 7.46514 10.6667 7.83333V10.5C10.6667 11.6046 9.77124 12.5 8.66667 12.5H2C0.895431 12.5 0 11.6046 0 10.5V3.83333C0 2.72876 0.895431 1.83333 2 1.83333H4.66667C5.03486 1.83333 5.33333 2.13181 5.33333 2.5C5.33333 2.86819 5.03486 3.16667 4.66667 3.16667H2Z"
      fill={colors.info.link}
    />
  </svg>
);

export default Link;
